import React from "react";
import { Img, ImgProps } from "@chakra-ui/react";

type CloudinaryProps = {
  src: string;
  alt: string;
};

export const Cloudinary = ({
  src,
  alt,
  ...props
}: CloudinaryProps & ImgProps) => (
  <Img
    alt={alt}
    src={
      "https://res.cloudinary.com/apollographql/image/upload/e_sharpen:50,q_90,fl_progressive/" +
      src
    }
    {...props}
  />
);
